import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Invoice\DeleteInvoiceController::deleteMethod
* @see app/Http/Controllers/Invoice/DeleteInvoiceController.php
* @route '/api/invoicing/{invoice}'
*/
export const deleteMethod = (args: { invoice: string | number | { id: string | number } } | [invoice: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: deleteMethod.url(args, options),
    method: 'delete',
})

deleteMethod.definition = {
    methods: ["delete"],
    url: '/api/invoicing/{invoice}',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\Invoice\DeleteInvoiceController::deleteMethod
* @see app/Http/Controllers/Invoice/DeleteInvoiceController.php
* @route '/api/invoicing/{invoice}'
*/
deleteMethod.url = (args: { invoice: string | number | { id: string | number } } | [invoice: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { invoice: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { invoice: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            invoice: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        invoice: typeof args.invoice === 'object'
        ? args.invoice.id
        : args.invoice,
    }

    return deleteMethod.definition.url
            .replace('{invoice}', parsedArgs.invoice.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Invoice\DeleteInvoiceController::deleteMethod
* @see app/Http/Controllers/Invoice/DeleteInvoiceController.php
* @route '/api/invoicing/{invoice}'
*/
deleteMethod.delete = (args: { invoice: string | number | { id: string | number } } | [invoice: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: deleteMethod.url(args, options),
    method: 'delete',
})

/**
* @see \App\Http\Controllers\Invoice\DeleteInvoiceController::undo
* @see app/Http/Controllers/Invoice/DeleteInvoiceController.php
* @route '/api/invoicing/{id}/undo-delete'
*/
export const undo = (args: { id: string | number } | [id: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: undo.url(args, options),
    method: 'get',
})

undo.definition = {
    methods: ["get","head"],
    url: '/api/invoicing/{id}/undo-delete',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Invoice\DeleteInvoiceController::undo
* @see app/Http/Controllers/Invoice/DeleteInvoiceController.php
* @route '/api/invoicing/{id}/undo-delete'
*/
undo.url = (args: { id: string | number } | [id: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { id: args }
    }

    if (Array.isArray(args)) {
        args = {
            id: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        id: args.id,
    }

    return undo.definition.url
            .replace('{id}', parsedArgs.id.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Invoice\DeleteInvoiceController::undo
* @see app/Http/Controllers/Invoice/DeleteInvoiceController.php
* @route '/api/invoicing/{id}/undo-delete'
*/
undo.get = (args: { id: string | number } | [id: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: undo.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Invoice\DeleteInvoiceController::undo
* @see app/Http/Controllers/Invoice/DeleteInvoiceController.php
* @route '/api/invoicing/{id}/undo-delete'
*/
undo.head = (args: { id: string | number } | [id: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: undo.url(args, options),
    method: 'head',
})

const DeleteInvoiceController = { deleteMethod, undo, delete: deleteMethod }

export default DeleteInvoiceController